import { render, staticRenderFns } from "./chairman-allowance.vue?vue&type=template&id=7d342c56&scoped=true&"
import script from "./chairman-allowance.vue?vue&type=script&lang=js&"
export * from "./chairman-allowance.vue?vue&type=script&lang=js&"
import style0 from "./chairman-allowance.vue?vue&type=style&index=0&id=7d342c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d342c56",
  null
  
)

export default component.exports